import * as React from 'react';
import { Button, Dialog, Typography, Slide, Box, Grid, MenuItem, TextField } from '@mui/material';
import TeamFormInput from '../../../pages/content/comman/TeamForm';
import FileUploadButton from '../../../pages/content/comman/TeamButton';
import { Controller } from 'react-hook-form';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenStatic({
  handleDialog,
  agentCreationModelOpen,
  handleSubmit,
  onFormSubmit,
  clearErrors,
  register,
  errors,
  control,
  updatingAgent,
  handleImageFunc,
  watch,
  handleType,
  handleAddMore
}) {
  return (
    <React.Fragment>
      <Dialog
        open={agentCreationModelOpen}
        onClose={handleDialog}
        TransitionComponent={Transition}
      >
        <Grid xs={12} sx={{ backgroundColor: "rgba(0, 165, 162, 0.7)", color: "white",padding: 2 }}>
          <Typography
            variant="h6"
            align="center"
          >
            {updatingAgent ? 'Update Employee' : 'Create Employee'}
          </Typography>
        </Grid>
        <Box sx={{ p: 3 }}>
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Controller
                  name="type"
                  control={control}
                  defaultValue="" // Provide a default value
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Employee Type"
                      select
                      onChange={handleType}
                      className={`form-control ${errors.detail_banner_desktop &&
                        errors?.detail_banner_desktop?.target
                        ? "error"
                        : ""
                        }`}
                    >
                      <MenuItem value="executive_team">Executive Team</MenuItem>
                      <MenuItem value="team_member">Team Member</MenuItem>
                    </TextField>
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`order`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      select
                      label="Enter Order"
                      className={`w-100 mb-2 ${errors && errors.order
                        ? "error"
                        : ""
                        }`}
                    >
                      {[...Array(80).keys()].map((number) => (
                        <MenuItem key={number + 1} value={(number + 1).toString()}>
                          {number + 1}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TeamFormInput
                  name="name"
                  control={control}
                  label="Employee Name"
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TeamFormInput
                  name="role"
                  control={control}
                  label="Employee Role"
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TeamFormInput
                  name="social_link"
                  control={control}
                  label="LinkedIn Url"
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TeamFormInput
                  name="employee_id"
                  control={control}
                  label="Employee ID"
                  errors={errors}
                />
              </Grid>

              {/* Photo */}
              <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'space-between', }}>
                <FileUploadButton
                  fieldName="img_src"
                  label="Upload Photo"
                  handleImageFunc={handleImageFunc}
                  register={register}
                  watch={watch}
                  clearErrors={clearErrors}
                  errors={errors}
                />
              </Grid>

              {/* Icon */}
              <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'space-between', }}>
                <FileUploadButton
                  fieldName="social_icon"
                  label="Upload Icon"
                  handleImageFunc={handleImageFunc}
                  register={register}
                  watch={watch}
                  clearErrors={clearErrors}
                  errors={errors}
                />
              </Grid>
            </Grid>
            <Grid item xs={6} textAlign="center" justifyContent={'center'} sx={{ marginTop: 5 }}>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  width: '100%',
                  maxWidth: '300px',
                  margin: 'auto',
                }}
              >
                {updatingAgent ? 'Update Employee' : 'Create Employee'}
              </Button>
            </Grid>
          </form>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
